module.exports = __webpack_public_path__ + "static/elsi_logo-198bda65036c3c8f07f863d0cde866c0.jpg";